import { render } from "./TubsComponent.vue?vue&type=template&id=51277a04&scoped=true"
import script from "./TubsComponent.vue?vue&type=script&lang=js"
export * from "./TubsComponent.vue?vue&type=script&lang=js"

import "./TubsComponent.vue?vue&type=style&index=0&id=51277a04&lang=scss&scoped=true"

import exportComponent from "/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51277a04"]])

export default __exports__